export const skillQueryKeys = {
    all: (agentId: number) => ["skill", "agent", agentId]
} as const;
